import BaseModel from '@/utils/store/BaseModel'
import User from '@/store/models/user/User'

class UserLike extends BaseModel {
  static entity = 'userlikes'

  static fields() {
    return {
      ...super.fields(),
      resourceType: this.attr(null),
      createdAt: this.attr(null).nullable(),
      // relationships
      userId: this.attr(null),
      user: this.belongsTo(User, 'userId'),
      resourceId: this.attr(null),
      resource: this.morphTo('resourceId', 'resourceType'),
    }
  }
}

export default UserLike
